module.exports = __webpack_public_path__ + "static/avatar1-3ebba1a9a0e0547c3e1eda715cb6cb24.png";